import * as React from 'react'
import styled from 'styled-components'

import * as glyphs from '../icons/glyphs'
import * as notification from '../styles/notification'

const calloutGlyphs: {
  [s in notification.CalloutType]: glyphs.IconElement
} = {
  alert: glyphs.fill.Alert,
  error: glyphs.fill.TimesCircle,
  info: glyphs.fill.Info,
  success: glyphs.fill.Success,
}

export type CalloutProps = {
  className?: string
  children: React.ReactNode
  customIcon?: glyphs.IconElement
  type: 'alert' | 'error' | 'info' | 'success'
  /** @default 'medium' */
  size?: 'small' | 'medium'
}

function CalloutComponent({
  className,
  children,
  customIcon: Icon,
  type,
  size = 'medium',
}: CalloutProps): React.ReactElement<CalloutProps> {
  const Glyph = calloutGlyphs[type]
  return (
    <notification.CalloutBackground className={className}>
      <notification.Callout type={type} size={size}>
        <notification.CalloutWrapper size={size}>
          {Icon ? <Icon size={16} /> : <Glyph size={18} />}
          <notification.CalloutSpan>{children}</notification.CalloutSpan>
        </notification.CalloutWrapper>
      </notification.Callout>
    </notification.CalloutBackground>
  )
}

export const Callout = styled(CalloutComponent)<CalloutProps>``
Callout.displayName = 'Callout'
